import axioPath from '../../../api/axioPath';
import { UPDATE_DATA } from 'redux/actions/action_types'

import { showAppLoader, hideAppLoader } from '../app';
// import _ from 'lodash';

export const isBuyingPaymentMethod = (token) => (dispatch) => {
    dispatch(showAppLoader())
    return axioPath
        .get('/user/paymentMethod/isBuyingPaymentMethodAttached', {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    dispatch(hideAppLoader());
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader());
            return ex;
        });
};
export const isSellingPaymentMethod = (token) => (dispatch) => {
    dispatch(showAppLoader())
    return axioPath
        .get('/user/paymentMethod/isSellingPaymentMethodAttached', {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    dispatch(hideAppLoader());
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader());
            return ex;
        });
};
export const userComments = (userType, id, token) => (dispatch) => {
    dispatch(showAppLoader())
    return axioPath
        .get('/user/userComments?userType=' + userType + '&userId=' + id, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    dispatch(hideAppLoader());
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader());
            if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
            else return ex;
        });
};
export const reportAbuse = (commentId, token) => (dispatch) => {
    dispatch(showAppLoader())
    return axioPath
        .post('user/report/abuse?commentId=' + commentId, '', {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    dispatch(hideAppLoader());
                },
                3000
            );

            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader())
            return ex;
        });
};
export const ratings = (token, data) => (dispatch) => {
    dispatch(showAppLoader())
    return axioPath
        .post('/order/all/ratings', data, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            setTimeout(
                () => {
                    dispatch(hideAppLoader());
                },
                3000
            );
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader());
            return ex;
        });
};
